/**
 * AppointmentHistorySection.js
 * Histórico do agendamento no drawer: quem criou, alterou, excluiu ou
 * registrou o pagamento, e quando. Recarrega quando o agendamento muda.
 */

import React from 'react';
import useActivityHistory from '../../../../../components/activity-history/useActivityHistory';
import ActivityHistoryList from '../../../../../components/activity-history/ActivityHistoryList';
import styles from './AppointmentDetailPanel.module.css';

function AppointmentHistorySection({ appointment }) {
  const refreshKey = [
    appointment.status, appointment.date, appointment.resource, appointment.procedure,
    appointment.roomId, appointment.duration, appointment.price, appointment.invoiceId,
    appointment.attendance_mode, appointment.meeting_url,
    appointment.billing_type, appointment.patient_insurance_id,
    (appointment.procedures || []).map(line => line.procedure_id).join(','),
    (appointment.stepChecks || []).map(check => check.stepId).join(','),
  ].join('|');
  const { entries, labels, isLoading, error } = useActivityHistory('appointment', appointment.id, refreshKey);

  return (
    <div className={styles.historySection}>
      <div className={styles.notesLabel}>Histórico</div>
      <ActivityHistoryList
        entries={entries}
        labels={labels}
        isLoading={isLoading}
        error={error}
        initialCount={3}
      />
    </div>
  );
}

export default AppointmentHistorySection;
